import {
  BookOpen,
  Bot,
  Cable,
  Folder,
  List,
  Plug,
  Workflow,
} from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';
import { SkillIcon } from 'components/core/skill-icon';

import type { MentionSearchType } from '../../types/mentions.service.type';

export type MentionPickerView = 'categories' | 'items';

type MentionIcon = ComponentType<SVGProps<SVGSVGElement>>;

const TYPE_ICON_MAP: Record<string, MentionIcon> = {
  skill: SkillIcon,
  skills: SkillIcon,
  prompt: BookOpen,
  prompts: BookOpen,
  integration: Plug,
  integrations: Plug,
  agent: Bot,
  agents: Bot,
  folder: Folder,
  folders: Folder,
  workflow: Workflow,
  workflows: Workflow,
};

const TYPE_LABEL_MAP: Record<string, string> = {
  skill: 'Skills',
  skills: 'Skills',
  prompt: 'Prompts',
  prompts: 'Prompts',
  integration: 'Integrations',
  integrations: 'Integrations',
  agent: 'Agents',
  agents: 'Agents',
  folder: 'Folders',
  folders: 'Folders',
  workflow: 'Workflows',
  workflows: 'Workflows',
};

export function normalizeMentionTypeKey(value: unknown): string | null {
  const raw = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (!raw) return null;

  if (TYPE_LABEL_MAP[raw] || TYPE_ICON_MAP[raw]) return raw;

  if (raw.endsWith('s') && raw.length > 1) {
    const singular = raw.slice(0, -1);
    if (TYPE_LABEL_MAP[singular] || TYPE_ICON_MAP[singular]) return singular;
  }

  return raw;
}

export function formatMentionTypeLabel(type: MentionSearchType): string {
  const key = normalizeMentionTypeKey(type) ?? type;
  if (TYPE_LABEL_MAP[key]) return TYPE_LABEL_MAP[key];
  if (TYPE_LABEL_MAP[`${key}s`]) return TYPE_LABEL_MAP[`${key}s`];

  return key
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getMentionCategoryIcon(type: MentionSearchType): MentionIcon {
  const key = normalizeMentionTypeKey(type) ?? type;
  return TYPE_ICON_MAP[key] ?? TYPE_ICON_MAP[`${key}s`] ?? List;
}

/** @deprecated Use formatMentionTypeLabel */
export function getMentionCategoryLabel(type: MentionSearchType): string {
  return formatMentionTypeLabel(type);
}
